import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { changeShare } from 'redux/propsSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const ShareModal = ({ property, setShow, setCheckChanges }) => {
  const dispatch = useDispatch();

  const [porcentaje, setPorcentaje] = useState(0);

  const handleClose = () => {
    setPorcentaje(0);
    setShow(false);
  };

  const handleSubmit = async () => {
    await dispatch(
      changeShare(
        property._id,
        porcentaje,
        porcentaje ? true : false,
        handleClose
      )
    );

    setCheckChanges(true);
  };

  const handleChange = e => {
    setPorcentaje(e.target.value);
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon="share"
          title="Eliminar"
          size="lg"
          className="me-2"
        />
        <Modal.Title>Compartir honorarios</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          La propiedad de dirección{' '}
          <b>
            {property.location.street} {property.location.number}
          </b>{' '}
          se compartirá.
          <br />
          <br />
          <Form.Label>
            Ingrese el porcentaje de honorarios que desea compartir con el
            inmobiliario:
          </Form.Label>
          <Row className="g-3">
            <Col xs={12} sm={6}>
              <Form.Group className="border px-3 py-2 bg-soft-success d-flex align-items-center">
                <Form.Check
                  type="radio"
                  name="share"
                  value="50"
                  onChange={handleChange}
                  className="m-0 me-2"
                />
                <Form.Label className="m-0">Comparte al 50%</Form.Label>
              </Form.Group>
            </Col>

            <Col xs={12} sm={6}>
              <Form.Group className="border px-3 py-2 bg-soft-info d-flex align-items-center">
                <Form.Check
                  type="radio"
                  name="share"
                  value="30"
                  onChange={handleChange}
                  className="m-0 me-2"
                />
                <Form.Label className="m-0">Comparte al 30%</Form.Label>
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className="border px-3 py-2 bg-light d-flex align-items-center">
                <Form.Check
                  type="radio"
                  name="share"
                  value=""
                  onChange={handleChange}
                  className="m-0 me-2"
                />

                <Form.Label className="m-0">No Comparte</Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <br />
          <h5>¿Está seguro de confirmar esta acción?</h5>
        </div>

        <ModalButtonsContainer>
          <ButtonClose
            style={{
              width: '100%'
            }}
            text="Cancelar"
            funcion={handleClose}
          />

          <ButtonAccept
            style={{
              width: '100%'
            }}
            text="Aceptar"
            funcion={handleSubmit}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

ShareModal.propTypes = {
  property: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  setCheckChanges: PropTypes.func.isRequired
};

export default ShareModal;
